import { cn } from '@/shared/lib/cn';

/**
 * Logo da marca trocando conforme o tema.
 *
 * ⚠️ As alturas dos dois temas são DIFERENTES de propósito. Os arquivos têm
 * enquadramentos distintos: `logo-nohra-light.png` é um quadrado 2000×2000 em
 * que a marca ocupa só a faixa do meio (~38% da altura) e `logo-nohra-dark.png`
 * é 2617×1472 com a marca ocupando ~68%. Com a mesma classe nos dois, a marca
 * do tema light sai quase pela metade do tamanho da outra — por isso cada
 * tamanho aqui é um PAR, com o light ≈ 1,78 × o dark.
 */
const TAMANHOS = {
  sm: { light: 'h-16', dark: 'h-9' },
  md: { light: 'h-28', dark: 'h-16' },
  lg: { light: 'h-44', dark: 'h-24' },
  xl: { light: 'h-64', dark: 'h-36' },
} as const;

export function LogoNohra({
  tamanho = 'md',
  className,
}: {
  tamanho?: keyof typeof TAMANHOS;
  /** Aplicado nas duas imagens — evite altura aqui, ela vem do `tamanho`. */
  className?: string;
}) {
  const { light, dark } = TAMANHOS[tamanho];

  return (
    <>
      <img
        src="/logo-nohra-light.png"
        alt="NOHRA Clinic"
        className={cn('w-auto object-contain dark:hidden', light, className)}
      />
      <img
        src="/logo-nohra-dark.png"
        alt="NOHRA Clinic"
        className={cn('hidden w-auto object-contain dark:block', dark, className)}
      />
    </>
  );
}
